import React, { createContext, useContext, useState } from 'react';
import { setImpersonatingId } from '../api';
import { queryClient } from '../queryClient';

const ImpersonationContext = createContext(null);

export function ImpersonationProvider({ children }) {
  const [impersonating, setImpersonating] = useState(null); // { id, email }

  function startImpersonating(user) {
    setImpersonatingId(user.id);
    setImpersonating(user);
    // Query keys are namespaced by impersonation id, but clear anyway so the
    // admin's own cached data isn't held in memory while impersonating.
    queryClient.clear();
  }

  function stopImpersonating() {
    setImpersonatingId(null);
    setImpersonating(null);
    queryClient.clear();
  }

  return (
    <ImpersonationContext.Provider value={{
      impersonating,
      startImpersonating,
      stopImpersonating,
    }}>
      {children}
    </ImpersonationContext.Provider>
  );
}

export function useImpersonation() {
  return useContext(ImpersonationContext);
}
